import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';

@Injectable({
	providedIn: 'root'
})
export class FormHelperService {

	constructor(
		private alertController: AlertController,
	) { }

	async alertUser(options?: { header?: string; message?: string }): Promise<void> {
		const defaultOptions = {
			header: 'Error',
			message: 'Required fields need reviewed.',
			buttons: ['OK'],
		};

		const alert = await this.alertController.create({ ...defaultOptions, ...options });

		await alert.present();
	}

	markAsTouched(form: FormGroup, trimWhitespace = false): FormGroup {
		if (form && form.controls) {
			for (const key in form.controls) {
				if (!form.controls.hasOwnProperty(key)) {
					continue;
				}

				const formValue = trimWhitespace && form.controls[key].value?.trim ?
					form.controls[key].value.trim() : form.controls[key].value;
				form.controls[key].setValue(formValue);
				form.controls[key].markAsTouched();
			}
		}

		return form;
	}

	compareWith(o1, o2): boolean {
		return o1 && o2 ? o1.id === o2.id : o1 === o2;
	}
}
